import { Box } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { RoutesUrl } from "../../common/consts/Routes";
import { find, findAndUpdate, store } from "../../services/service";
import CardComponent from "../shared/CardComponent";
import FormComponent, { FormData } from "../shared/test";

function NewClient() {
  let { id }: any = useParams();
  const { push } = useHistory();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [formData, setFormData] = useState<FormData>({
    dynamicRows: [] as any,
  });
  useEffect(() => {
    if (id) {
      setIsLoading(true);
      find("data", id)
        .then((val) => {
          if (!!!val?.dynamicRows) {
            val.dynamicRows = [];
          }
          setFormData(val);
        })
        .finally(() => setIsLoading(false));
    } else {
      setFormData({
        dynamicRows: [] as any,
      });
    }
  }, [id]);
  console.log(formData);
  return (
    <Box>
      <CardComponent title={`New Data`} isLoading={isLoading}>
        <FormComponent
          staticFields={[
            {
              name: "campaign-name",
              label: "Име на кампанията",
              type: "text",
              required: true
            },
            {
              name: "target-audience",
              label: "Информация за целевата аудитория",
              type: "text",
              required: true,
              textFieldProps: {
                multiline: true,

              }
            },
            {
              name: "campaign-goal",
              label: "Цел на кампанията",
              type: "text",
              required: true,
              textFieldProps: {
                multiline: true,

              }
            },
            {
              name: "product-description",
              label: "Описание на продукта или услугата",
              type: "text",
              required: true,
              textFieldProps: {
                multiline: true,

              }
            },
            {
              name: "brand-description",
              label: "Описание на бранда или марката",
              type: "text",
              required: true,
              textFieldProps: {
                multiline: true,

              }
            },
            {
              name: "key-messages",
              label: "Ключови послания",
              type: "text",
              required: true,
              textFieldProps: {
                multiline: true,

              }
            },
            {
              name: "call-to-action",
              label: "Информация за желаното дейстие от клиента (Call to Action)",
              type: "text",
              required: true,
              textFieldProps: {
                multiline: true,

              }
            },
            {
              name: "additional-info",
              label: "Допълнителна информация",
              type: "text",
              required: false,
              textFieldProps: {
                multiline: true,

              }
            }
          ]}

          dynamicPlural="Лицa за контакт"
          dynamicSingle="Лице за контакт"
          onSubmit={async (data) => {
            try {
              if (id) {
                await findAndUpdate("data", id, data);
                toast.success("Успешно редактиране");
                push(RoutesUrl.parametricsPro.list);
                return;
              }
              await store("data", data);
              toast.success("Успешно добавяне");
              push(RoutesUrl.parametricsPro.list);
              return true;
            } catch (e) {
              toast.error("Нещо се обърка");
              console.error(e);
              return false;
            }
          }}
          editMode={id ? true : false}
          formData={formData}
          setFormData={setFormData}
        />
      </CardComponent>
    </Box>
  )
}

export default NewClient;